// Module
var code = "<select name=\"vm.propertyName\" class=\"form-control input-sm\" ng-model=\"vm.model\" ng-disabled=\"vm.isDisabled\"> <option value=\"0\">{{'Increasing'|translate}}</option> <option value=\"1\">{{'Decreasing'|translate}}</option> </select>";
// Exports
module.exports = code;